module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: [
      'header',
      {
        'header--fixed': _vm.fixed,
      } ]
  }, [_c('b', {
    class: [
      "header__bg",
      {
        'header__bg--fixed': _vm.fixed,
      } ]
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [(!_vm.isAuthenticated) ? _c('a', {
    staticClass: "header__logo",
    attrs: {
      "href": _vm.wpUrl
    }
  }, [_c('module-logo')], 1) : _c('router-link', {
    class: "header__logo",
    attrs: {
      "to": {
        name: "dashboard"
      }
    }
  }, [_c('module-logo')], 1), _vm._v(" "), _c('ui-navigation')], 1), _vm._v(" "), (!_vm.isAuthenticated) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('span', {
    staticClass: "header__links"
  }, _vm._l((_vm.headerLinks), function(headerLink) {
    return _c('module-link', {
      key: headerLink.name,
      staticClass: "header__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": headerLink.name,
        "label": headerLink.label,
        "external": false
      }
    })
  }))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a1fa04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Header.vue
// module id = 128
// module chunks = 3